import {get} from '../utils'

export default host => ( clientId ) =>
  get(`${host}/clients/${clientId}/persons/filters`)
    .then(response => response.json())
